// BOORO: the Chief delegates instead of working through a queue of its own.
import { CHIEF_GUIDANCE } from "./chief.js";

/** Runs started by a person talking to the agent; work requested there becomes tasks. */
const CONVERSATION_TRIGGERS = new Set(["user", "follow_up"]);

export const TASK_CREATION_GUIDANCE = [
  "Tasks: answer questions and quick requests directly.",
  "When the user asks for work that needs tools or takes more than a moment, create one task per distinct piece of work with ticket_create (owner yourself unless the user names another agent). Write the title as a short imperative in the user's language and put what done means into the description.",
  "Then confirm in one short sentence and stop. The tasks run next, one after another, each in its own run; do not start the work in this reply.",
].join(" ");

export const TASK_WORK_GUIDANCE = [
  "You are working on one task. Stay on it and do not create tasks for yourself; delegate to another agent only when the task asks for it.",
  "If the title is long or unclear, replace it with a short imperative in the user's language using ticket_update.",
  "Attach every file the user should see or check (images, video, audio, documents) with attach_file; a path in your text is not visible to them, so never say a file is attached unless attach_file succeeded. For an updated file, attach it again under the same name.",
  "When it is finished, call ticket_update with status done and result: one sentence in the user's language saying what came out. If you cannot continue, use blocked; if the user must decide or check something, use review. Give a result sentence there too.",
].join(" ");

export function taskGuidanceForRun(run: {
  boardEnabled: boolean;
  trigger: string;
  groupChat: boolean;
  messagingChannelRun: boolean;
  /** The Chief hands out work instead of working through a queue of its own. */
  chief?: boolean;
}): string | undefined {
  if (!run.boardEnabled || run.groupChat || run.messagingChannelRun) return undefined;
  if (run.chief) return CHIEF_GUIDANCE;
  if (run.trigger === "tickets") return TASK_WORK_GUIDANCE;
  if (CONVERSATION_TRIGGERS.has(run.trigger)) return TASK_CREATION_GUIDANCE;
  return undefined;
}

/** Appends task guidance to the run's ticket context, keeping either when the other is absent. */
export function withTaskGuidance(
  ticketContext: string | undefined,
  guidance: string | undefined,
): string | undefined {
  return [ticketContext, guidance].filter(Boolean).join("\n\n") || undefined;
}
